const themesHandler = () => {
    return [
        {
            theme_supports: {}
        }
    ]
}

export default themesHandler
